import Carousel from 'react-bootstrap/Carousel';

//  import slide3 from '../../assets/img/slides/Slide1.png'
import './slider.css'

import  slide3 from '../../assets/img/slides/Slide.png'
import  slide4 from '../../assets/img/slides/Slide2.png'
import { Container} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import React from 'react'
function Slider(props) {

 
  return (

<section className="home-hero" aria-label="Hero carousel">
  <div className="home-hero-inner">
    <Carousel fade data-bs-theme="dark">
    <Carousel.Item>
      <img
        className="d-block w-100 img-fluid"
        src={slide3}
        alt="First slide"
      />
      <Carousel.Caption className="slider-caption">
        <span className="slider-badge">Weekly offer</span>
        <h5 className="slider-title">20% off braiding, styles & weaves</h5>
        <p className="slider-desc">20% off all braiding, styles, weaves and other selected services.</p>
        <Button className="btn-rita slider-cta" variant=""><Link to="appointment">Book Appointment</Link></Button>
      </Carousel.Caption>
     
    </Carousel.Item>
    <Carousel.Item>
      <img
        className="d-block w-100"
        src={slide4}
        alt="Second slide"
      />
      <Carousel.Caption className="slider-caption">
        <h5 className="slider-title">Braiding — our specialty</h5>
        <p className="slider-desc">We specialize in all kinds of braiding services.</p>
      </Carousel.Caption>
    </Carousel.Item>
    <Carousel.Item>
      <img
        className="d-block w-100"
        src={slide3}
        alt="Third slide"
      />


      <Carousel.Caption className="slider-caption">
        <h5 className="slider-title">Hair services</h5>
        <p className="slider-desc">We specialize in all kinds of hair services.</p>
      </Carousel.Caption>
    </Carousel.Item>
  </Carousel>
  </div>
</section>
  );
}

export default Slider;